module.exports = __webpack_public_path__ + "img/12.41300c15.jpg";